import { app } from '../../app';
import { Controller } from './sp-user-status.controller';

app.component('spUserStatus', {
    bindings: {
        status: '<',
        blockedStatus: '<',
        tooltipPlacement: '@',
    },
    controller: Controller,
    templateUrl: require('./sp-user-status.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/sp-user-status/sp-user-status.component.js